export const selectCompilations = state => state.compilations;
